// @todo create a function to generate automatically theses properties
// authorized lets you know if the token is true or not
import { AttributeCore } from '@/models';

export default {
  attributes: state => state.attributes.map(a => AttributeCore(a)) || [],
  attribute: state => AttributeCore(state.attribute) || null,
};
